import { useEffect, useState } from "react";
import QuestionAudioPlayer from "./QuestionAudioPlayer";
import { getQuestionMediaLabel } from "../assets/utils/questionMedia";
import q from "../styles/components/examQuestion.module.scss";

const QuestionAudioList = ({ voices = [], idPrefix = "question" }) => {
    const [activeVoiceId, setActiveVoiceId] = useState(null);

    useEffect(() => {
        setActiveVoiceId(null);
    }, [voices]);

    if (!voices.length) return null;

    const isMulti = voices.length > 1;

    return (
        <div className={q.audioList}>
            {isMulti && (
                <p className={q.mediaSectionLabel}>{`${voices.length} فایل صوتی`}</p>
            )}
            {voices.map((voice, index) => {
                const voiceId = voice.id ?? `${idPrefix}-voice-${index}`;
                return (
                    <div key={voiceId} className={q.audioListItem}>
                        {(isMulti || voice.original_name) && (
                            <p className={q.audioListLabel}>
                                {getQuestionMediaLabel(voice, index, "صوت")}
                            </p>
                        )}
                        <QuestionAudioPlayer
                            audioURL={voice.path}
                            id={voiceId}
                            isActive={activeVoiceId === voiceId}
                            onActivate={() => setActiveVoiceId(voiceId)}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default QuestionAudioList;
